import { HotTable } from '@handsontable/react';
import 'bootstrap/dist/css/bootstrap.css';
import 'handsontable/dist/handsontable.full.css';
import $ from 'jquery';
import { toJS } from "mobx";
import { observer } from "mobx-react";
import React, { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import { insertRowCtrl, saveValueNew } from '../control';
import { dismissWarning, localizeNumber, normalizeSelectInput, toNumber } from '../helpers';
import { convertTeamToID, DbSortFunctionForAssets, isDerivativesCategory, isInternalStyle, mapInternalTeam, returnTypeIDOptions, getOptionsArray, mapToDropdownOption, mapCustomGroupings, convertCustomGroupingToID } from "../ibsHelper";
import ibsStore from './Stores/IbsSurveyStore';
import store from './Stores/SurveyStore';
import { UpdateMandateInfoSingle } from '../Services/IBS/DbService';
import { calculateTotal, calculateForChildren } from '../Helpers/TableCalculationHelper';
import { MandateTableButtons } from './TableComponents/DB/Asset Mandate Table/MandateTableButtons';
import { mandateToAssetMapping, mandateToAssetErrorMapping } from './TableComponents/DB/Asset Mandate Table/MandateTableFieldMappings';
import { getHiddenMandateColumns } from './TableComponents/DB/Asset Mandate Table/AssetMandateTableHandler';
import { openMandatesActionModal, openExplanationModal } from '../Helpers/ModalControl';
import { manageContainerWidth, updateColumnWidths, getAssetTableHeaders, isCellNA } from '../Helpers/TableHelper';
import { RowFactory } from './TableComponents/DB/Asset Mandate Table/RowFactory';
import { NumberFormat, SelectCombosIBS, AssetTableViewMode } from '../Enums/constants';
import { checkAnyAssetCellFilled, checkAnyMandateFilled, assetMandateCellRenderer, dropdownNARenderer } from './TableComponents/DB/Asset Mandate Table/AssetMandateCellRenderer';
import { formatNumber } from '../Helpers/General/FormatHelper';
import { getSurveyResponseValue } from '../Helpers/General/SurveyResponsesHelper';
import { refreshDefaults } from '../Helpers/DefaultsHelper';


var classNames = require('classnames');

const SurveyMandateTable = observer((props) => {
    const hotTableInstance = useRef(null);

    var referenceToTable = []
    var dataObj = [];
    var listOfHeaderRows = [];
    var listOfAssetRows = [];
    var rowJustAdded;
    var listOfOverrides = [];
    var listOfCalculated = [];
    var listOfErrorWarning = [];
    let colWidthsOverrides = {
    };

    /* --------- DEBUG --------- */
    let debug = 0;

    function log(message, threshold) {
        let color = 'color: #00FF00';
        switch (threshold) {
            case 1:
                color = 'color: #FF0000; background-color: #FFFFFF;';
                break;
            case 2:
                color = 'color: #0000FF; background-color: #FFFFFF;';
                break;
            case 3:
                color = 'color: #FF0000;';
                break;
            case 4:
                color = 'color: #00FF00;';
                break;
            case 5:
                color = '';
                break;
            default:
                color = 'color: #00FF00';
                break;
        }
        if (process.env.NODE_ENV !== 'production') {
            if (threshold > 1) {
                if (debug >= threshold) {
                    console.log(`%c${message}`, color);
                }
            } else {
                if (debug) {
                    console.log(`%c${message}`, color);
                }
            }
        }
    }

    const handleHOTChange = (table, rowNum, qId, oldValue, newValue) => {
        log(`handleHOTChange`, 1);
        var hot = hotTableInstance?.current?.hotInstance;
        if (typeof hot == "undefined" || hot == null) {
            return;
        }
        let rowId = referenceToTable[rowNum].RowID //the rowId 
        var rowIdAsset = rowId;
        let tableName = props.tableName;
        let result;

        if (qId == "ManagerName" || qId == "FundName" || qId == "AssetClassName" || qId == "StyleName") return

        if (newValue === "Add or edit teams") {
            store.showInternalTeamModal = true
            return
        }
        else if (newValue === "Add or edit groupings") {
            store.showCustomGroupingModal = true
            return
        }
        if (newValue === "...") {
            newValue = null
        }
        if (rowNum !== null && qId !== null && newValue !== oldValue && newValue !== 'undefined') { //test
            const col = table.propToCol(qId);

            let cellFormat = undefined;
            if (props.formatting && props.formatting[col])
                cellFormat = props.formatting[col];
            const isNumField = Object.values(NumberFormat).indexOf(cellFormat) > -1;

            let normalizedNewValue = newValue;

            // This entire section needs reworking, copied from old table code?
            if ((qId == "ReturnPct") && store.local.naList.includes(newValue)) {
                let tableToSave = tableName;
                let tempRowId;
                if (rowId.toString().substring(0, 1) === 'A') {
                    tempRowId = rowId.replace('A', '')
                    tableToSave = "combinedAssets"
                    let index = ibsStore.allTableResponses["combinedAssets"].findIndex(row => row.RowID == tempRowId);
                    ibsStore.allTableResponses["combinedAssets"][index]["IsReturnNA"] = true;
                }
                else {
                    tempRowId = rowId
                }
                saveValueNew("IsReturnNA", true, { tableName: tableToSave, rowId: tempRowId });
                normalizedNewValue = "";
                newValue = "";


            } else if ((qId == "ReturnPct") && !(store.local.naList.includes(newValue))) {
                let tableToSave = tableName;
                let tempRowId;
                if (rowId.toString().substring(0, 1) === 'A') {
                    tempRowId = rowId.replace('A', '')
                    tableToSave = "combinedAssets"
                    let index = ibsStore.allTableResponses["combinedAssets"].findIndex(row => row.RowID == tempRowId);
                    ibsStore.allTableResponses["combinedAssets"][index]["IsReturnNA"] = false;
                }
                else {
                    tempRowId = rowId
                }
                saveValueNew("IsReturnNA", false, { tableName: tableToSave, rowId: tempRowId })
            }

            if (isNumField && !store.local.naList.includes(newValue)) {
                normalizedNewValue = toNumber(newValue);
                if (Number.isNaN(normalizedNewValue)) {
                    // It's a number field, but newValue is not a number
                    // just save an empty value
                    normalizedNewValue = null;
                }
            }

            if (qId === "InternalTeamID") normalizedNewValue = convertTeamToID(qId, newValue)
            else if (qId === "CustomAssetID") normalizedNewValue = convertCustomGroupingToID(qId, newValue)
            else if (qId === "ReturnTypeIDAssets") normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.ASSET_RETURN_TYPES)
            else if (qId === "ReportIncludeStatus") normalizedNewValue = normalizeSelectInput(newValue, SelectCombosIBS.REPORT_INCLUSION_OPTS)
            else if (qId === "LifeCycleStatus") {
                let result = ibsStore.mandateData.find(obj => obj.rowID == rowId)
                if (result) {
                    let mandateId = result.mandateID;
                    let value = normalizeSelectInput(newValue, SelectCombosIBS.LIFECYCLE_TYPES);
                    UpdateMandateInfoSingle(qId, value, mandateId)

                    result = ibsStore.mandateData.findIndex(row => row.rowID == rowId);
                    let questionName = qId.charAt(0).toLowerCase() + qId.slice(1) //preferably get rid of this in the future
                    ibsStore.mandateData[result][questionName] = normalizeSelectInput(newValue, SelectCombosIBS.LIFECYCLE_TYPES);
                }
                return;
            }

            if (rowId.toString().substring(0, 1) === 'A') {
                //save to asset table
                tableName = "combinedAssets";
                rowId = rowId.substring(1);
                result = ibsStore.allTableResponses["combinedAssets"].findIndex(row => row.RowID == rowId); //where it is saved on from end;
                qId = mandateToAssetMapping[qId];

                //special case
                if (qId === "CostThousands") {
                    let styleForRow = ibsStore.allTableResponses["combinedAssets"][result].StyleID
                    if (isInternalStyle(styleForRow)) {
                        qId = "CostThousands"
                    } else {
                        qId = "InternalMonitoringCost"
                    }
                }
                let catName = ibsStore.allTableResponses["combinedAssets"][result].AssetClassCategoryName

                if (qId === "FeesPaidHoldingsMillions" || qId == "HoldingFeeAvg") {
                    if (isDerivativesCategory(catName)) {
                        qId = "NotionalAmount"
                    } else {
                        qId = "FeesPaidHoldingsMillions"
                    }
                }
                if (qId === "ReturnPercent" && isDerivativesCategory(catName)) {
                    qId = "DerivPerfThousands"
                }

                //console.log(qId)
                ibsStore.allTableResponses["combinedAssets"][result][qId] = normalizedNewValue;
            } else {
                //its an mandate row
                result = ibsStore.mandateData.findIndex(row => row.rowID == rowId); //where it is saved on front end
                let catName = ibsStore.mandateData[result]?.assetClassCategoryName
                let styleForRow = ibsStore.mandateData[result]?.styleID

                //special case
                if (qId === "CostInternManage") {
                    referenceToTable[rowNum][qId] = normalizedNewValue
                    if (isInternalStyle(styleForRow)) {
                        qId = "costInternManage"
                    } else {
                        qId = "costInternMonitor"
                    }
                }
                else if (qId === "HoldingFeeAvg") {

                    if (isDerivativesCategory(catName)) {
                        qId = "NotionalAmount"

                    }
                } else if (qId === "ReturnPct") {
                    if (isDerivativesCategory(catName)) {
                        qId = "DerivProfit"

                    }
                }


                if (rowNum == referenceToTable.length - 1) {
                    return;
                } else {

                }


                //save in ref table
                referenceToTable[rowNum][qId] = newValue
                let questionName = qId.charAt(0).toLowerCase() + qId.slice(1) //preferably get rid of this in the future
                let mandate = ibsStore.mandateData[result]

                mandate[questionName] = normalizedNewValue

                let defaultForSavedIndex = ibsStore.defaultCoordinates.findIndex(def => def.rowID === rowId && def.qName == qId);
                ibsStore.defaultCoordinates.splice(defaultForSavedIndex, 1)
                if (ibsStore.isMandateDefaultsShown) { refreshDefaults(rowId) }

            }
            let rulesSet = saveValueNew(qId, normalizedNewValue, { tableName, rowId })
            rulesSet.then(function (result) {
                let errors
                if (result) errors = result["assets"]
                //for each rule info, find the colprop index and use the rowid to convert to actual row# (its usually same row but eh); also should save to validation list without it being observable!!
                if (errors) {
                    errors.forEach(element => {

                        if (element != null) {
                            if (element["QuestionName"] === "NotionalAmount") { element["QuestionName"] = "HoldingFeeAvg" }
                            let colNum;
                            if (hot) colNum = hot.propToCol(element["QuestionName"])
                            if (rowIdAsset && rowIdAsset.toString().substring(0, 1) !== 'A') {
                                hot.setCellMeta(rowNum, colNum, "errorObj", element)
                            }

                            hot.render()
                        }
    
                    })

                }

            })
            let changedMandatesParentId = referenceToTable[rowNum].ParentAssetRowId
            if (!changedMandatesParentId) return
            let parentRowIndex = referenceToTable.findIndex(elem => { return (elem.RowID == changedMandatesParentId) })
            let childrenMandates = referenceToTable.filter(row => row.ParentAssetRowId == changedMandatesParentId)
            let assetId = mandateToAssetMapping[qId]
            let realAssetValue = ibsStore.allTableResponses["combinedAssets"].filter(asset => asset.RowID == changedMandatesParentId?.toString().substring(1))
            let mandateLevelInt = null
            if (typeof ibsStore.checkMandateLevel !== "undefined" && ibsStore.checkMandateLevel !== null) {
              mandateLevelInt = parseInt(ibsStore.checkMandateLevel, 10);
            }

            if (mandateLevelInt == AssetTableViewMode.BOTH_VIEW && rowId.toString().substring(0, 1) !== 'A' && qId != "ReturnTypeIDAssets" && qId != "IsReturnNA" && qId != "LifeCycleStatus" && qId != "ReportIncludeStatus" && qId != "DerivProfit" && qId != "InternalTeamID" && qId != "CustomAssetID") {
                let calcChildren = calculateForChildren(childrenMandates, qId, realAssetValue[0][assetId], changedMandatesParentId.toString().substring(1), listOfOverrides, listOfCalculated)

                if (qId == "costInternMonitor" || qId == "costInternManage") qId = "CostInternManage"
                if (qId == "NotionalAmount") qId = "HoldingFeeAvg"
                if (qId == "DerivProfit") qId = "ReturnPct"
                if (isInternalStyle(realAssetValue[0]["StyleID"])) {
                    if (qId == "CostInternManage" || qId == "costInternMonitor" || qId == "costInternManage") {
                        assetId = "CostThousands"
                    }
                    else {
                        assetId = "InternalMonitoringCost"
                    }
                }
                hot.setDataAtCell(parentRowIndex, hot.propToCol(qId), parseFloat(calcChildren), "skipHotChange")
                referenceToTable[parentRowIndex][hot.propToCol(qId)] = parseFloat(calcChildren)

                //if HoldingNav then force a calculation for asset return % because its weighted and dependent on it
                if (qId == "HoldingNavAvg") {
                    let calcChildren = calculateForChildren(childrenMandates, "ReturnPct", realAssetValue[0][assetId], changedMandatesParentId.toString().substring(1), listOfOverrides, listOfCalculated)
                    hot.setDataAtCell(parentRowIndex, hot.propToCol("ReturnPct"), parseFloat(calcChildren), "skipHotChange")
                    referenceToTable[parentRowIndex][hot.propToCol("ReturnPct")] = parseFloat(calcChildren)

                    //Find linked row in Private Equity table if style is 16
                    if (realAssetValue[0]["StyleID"] == 16) {
                        let mandate = ibsStore.mandateData[result]
                        let i = ibsStore.allTableResponses["PrivateEquity"].findIndex(obj => obj.MandateID == mandate.mandateID)
                        let linkedRowID = ibsStore.allTableResponses["PrivateEquity"][i].RowID

                        if (i >= 0) {
                            saveValueNew("NetAssetValueMil", normalizedNewValue, { tableName: "PrivateEquity", rowId: linkedRowID })
                            ibsStore.allTableResponses["PrivateEquity"][i].NetAssetValueMil = normalizedNewValue
                        }
                    }

                }
            }


            //total at the column level
            if (qId != "ReturnPercent" && qId != "ReturnPct" && qId != "DerivProfit" && qId != "InternalTeamID" && qId != "CustomAssetID" && qId != "ReturnTypeIDAssets") {
                let format = NumberFormat.MONEYTHOUSAND
                if (qId == "HoldingFeeAvg") format = NumberFormat.MONEYMILLION
                let colCalcRedo = columnCalculation(qId, format);
                hot.setDataAtCell(referenceToTable.length - 1, col, colCalcRedo, "skipHotChange");
            }

            //totals for the 4 perf/base fees + internal in the total column [manual target method]
            let totalQuestions = ["CostManagerBase", "CostManagerPerf", "CostUnderlyBase", "CostUnderlyPerf", "costInternManage", "costInternMonitor", "CostInternManage"]
            let mandate = ibsStore.mandateData[result]
            if (totalQuestions.includes(qId)) {
                let total = localizeNumber(calculateTotal([referenceToTable[rowNum]["CostManagerBase"], referenceToTable[rowNum]["CostManagerPerf"], referenceToTable[rowNum]["CostUnderlyBase"],
                referenceToTable[rowNum]["CostUnderlyPerf"], referenceToTable[rowNum]["CostInternManage"]], mandate.rowID))
                hot.setDataAtCell(rowNum, 14, total.toString(), "skipHotChange"); //alt way to calculation column realtime
                referenceToTable[rowNum][14] = total

                hot.setDataAtRowProp(referenceToTable.length - 1, "totalRowCost", columnCalculation("totalRowCost", NumberFormat.MONEYTHOUSAND), "skipHotChange");

            }

        }
    }




    const manageColumnWidths = () => {
        log(`manageColumnWidths`, 2);
        if (hotTableInstance?.current?.hotInstance && colWidthsOverrides[props.tableName]) {
            let hot = hotTableInstance.current.hotInstance;
            var resizePlugin = hot.getPlugin("manualColumnResize");
            let idxArr = Object.keys(colWidthsOverrides[props.tableName]);
            idxArr.forEach(idx => {
                resizePlugin.setManualSize(idx, colWidthsOverrides[props.tableName][idx]);
            });
        }
    }

    //special DB Asset Renderers
    const categoryRowRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        log(`categoryRowRenderer`, 4);
        td.innerHTML = value
        td.className = td.className + "categoryRow"
        cellProperties.cellType = "text";
        if (prop !== "AssetClassCategoryName") td.className += " categorySubColHeader"

        if (prop === "AssetClassCategoryName" && value !== "") {
            lastEncounteredAssetCat = value
        }

    }

    const readOnlyRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        log(`readOnlyRenderer`, 1);
        td.className = td.className + "readOnlyCell"
        cellProperties.readOnly = true;
    }

    

    let lastEncounteredImplStyle = undefined;
    let lastEncounteredAssetCat = undefined;

    const errorRenderer = (td, row, col, prop, value, cellProperties) => {
        if (referenceToTable[row]) var currentRowID = referenceToTable[row].RowID

        // Error Rendering segment from categoryRowRenderer
        if (currentRowID == "Total") {
            let mandateName = typeof mandateToAssetErrorMapping[prop] === 'undefined' ? "" : mandateToAssetErrorMapping[prop];
            var warningErrorIndex = listOfErrorWarning.findIndex(function (v, i) {
                return ((v["errorTotalCol"] != null && (v["errorTotalCol"].toLowerCase() == prop.toLowerCase() || v["errorTotalCol"].toLowerCase() == mandateName.toLowerCase())));
            })

            if (warningErrorIndex == -1) {
                warningErrorIndex = listOfErrorWarning.findIndex(function (v, i) {
                    return v["rowID"]?.toString() === currentRowID?.toString() && v["qName"]?.toLowerCase() === prop.toLowerCase();
                });
            }

            if (warningErrorIndex != -1 && !ibsStore.isMandateDefaultsShown) {

                var backgroundColor = '#f9f9f9';
                var warningError = listOfErrorWarning[warningErrorIndex];

                var span = document.createElement("span")
                span.className = "genericTooltip tooltiptext"
                if (value != null && value.length == "") {
                    var testWidth = td.offsetWidth;
                    span.style.marginLeft = `${testWidth}px`;
                }


                span.innerHTML = warningError.errorMessage

                var clickTextOpt1 = document.createElement("a")
                var clickTextOpt2 = document.createElement("a")
                var orText = document.createElement("span")
                clickTextOpt1.addEventListener('click', function () {
                    openExplanationModal(warningError.rowID, warningError.errorId, value, warningError);
                }, false);
                clickTextOpt2.addEventListener('click', function () {
                    dismissWarning(warningError.qName, warningError.rowID, warningError.errorId, store.local.dismissText);
                }, false);

                clickTextOpt2.innerHTML = `click to dismiss`
                clickTextOpt2.className = "click-to-dismiss"
                orText.innerHTML = " or "

                if (warningError.errorTypeID == 2 || warningError.errorTypeID == 1) {
                    if (warningError.errorExplanation == null || warningError.errorExplanation.length == 0) {
                        clickTextOpt1.innerHTML = `<br/>Add Explanation`
                        clickTextOpt1.className = "click-to-dismiss"

                        span.appendChild(clickTextOpt1)
                        span.appendChild(orText)
                        span.appendChild(clickTextOpt2)
                        td.className = "validationWarning"
                        backgroundColor = "#f4f1cf";
                    }
                    else {
                        td.className = "dismissed"
                        clickTextOpt1.innerHTML = warningError.errorExplanation
                        clickTextOpt1.className = "error-explanation-text"

                        span.innerHTML += '<br/>Your comment: '
                        span.appendChild(clickTextOpt1)
                        backgroundColor = "#d3eed2";

                    }
                }
                else if (warningError.errorTypeID == 0) {
                    td.className = "validationError"
                    backgroundColor = "#f4d4cf";
                }

                td.className = td.className + " tooltipCustom"
                var rightAligndiv = document.createElement("div");
                rightAligndiv.className = "rightAligned";
                rightAligndiv.appendChild(span);
                td.appendChild(rightAligndiv);
            }
            td.style.setProperty("background-color", backgroundColor, "important");
        }
        else {

            let assetProp = mandateToAssetErrorMapping[prop];

            var warningErrorIndex = assetProp === undefined ? -1
                : listOfErrorWarning.findIndex(function (v, i) {
                    return v["rowID"]?.toString() === currentRowID?.toString().replace("A", "") && v["qName"]?.toLowerCase() === assetProp.toLowerCase();
                });
            if (warningErrorIndex == -1) {
                warningErrorIndex = listOfErrorWarning.findIndex(function (v, i) {

                    var questionName = v["qName"]?.toLowerCase();
                    // Going to have to be updated with other errors in the future
                    // Due to CostInternManage column being filled with multiple different fields
                    if (questionName === "internalmonitoringcost") {
                        questionName = "costinternmanage";
                    }
                    return v["rowID"]?.toString() === currentRowID?.toString().replace("A", "") && questionName === prop.toLowerCase();
                });
            }

            let isOverride = listOfOverrides.findIndex(function (v, i) {
                return v["rowID"]?.toString() === currentRowID?.toString() && v["qName"].toLowerCase() === prop?.toString().toLowerCase();
            })

            let isCalculated = listOfCalculated.findIndex(function (v, i) {
                return v["rowID"]?.toString() === currentRowID?.toString() && v["qName"].toLowerCase() === prop?.toString().toLowerCase();
            });

            let mappedName = mandateToAssetMapping[prop]

            let isDefault = ibsStore.defaultCoordinates.findIndex(function (v, i) {
                return v["rowID"]?.toString() === currentRowID?.toString() && (v["qName"]?.toLowerCase() === prop?.toString().toLowerCase() || v["qName"]?.toLowerCase() === mappedName?.toString().toLowerCase());
            });

            if (warningErrorIndex !== -1 || (value !== "N/A" && (isDefault > -1 || isCalculated > -1 || isOverride > -1))) {

                var hasAdded = false;
                let span = document.createElement("span");
                let orText2 = document.createElement("span")

                span.className = "genericTooltip tooltiptext";
                span.innerHTML = "";
                let warningError = listOfErrorWarning[warningErrorIndex];
                var tooltipMsg = "";
                if (value !== "N/A" && td.innerHTML != "N/A") {
                    if (warningErrorIndex !== -1 && !ibsStore.isMandateDefaultsShown) {
                        //Extra Default option
                        if (isDefault > -1) {
                            let valFormatted = formatNumber(props.formatting[col], toNumber(ibsStore.defaultCoordinates[isDefault].value));
                            let averageVal = toNumber(ibsStore.defaultCoordinates[isDefault].average);
                            let averageFormatted = formatNumber(NumberFormat.MONEYDECIMAL1, Number.isNaN(averageVal) ? 0 : averageVal);
                            let clickTextOptReplaceDefault = document.createElement("a");

                            span.innerHTML += ibsStore.defaultCoordinates[isDefault].message.replace("{0}", valFormatted).replace("{1}", averageFormatted);
                            span.innerHTML += "<br/><br/>"


                        }
                        hasAdded = true;

                        var metaCellErrorInfo = hotTableInstance?.current?.hotInstance?.getCellMeta(row, col) ?? {};
                        let newMsg = ""

                        /* TODO: Flagged .errorObj lines below to be deleted(?) as the property never appears in the project */
                        //Realtime render of the warning or error cells on return of a save request
                        if (metaCellErrorInfo.errorObj && metaCellErrorInfo.errorObj.RuleStatus == "Fail") {
                            newMsg = metaCellErrorInfo["errorObj"]["ErrorMessage"]
                            td.className = td.className + " validationWarning"

                        } else if (metaCellErrorInfo.errorObj && metaCellErrorInfo.errorObj.RuleStatus == "Pass") {
                            td.className = td.className + ""
                            return
                        }
                        else {
                            newMsg = newMsg + warningError.errorMessage;
                        }
                        span.innerHTML += newMsg
                        let clickTextOpt1 = document.createElement("a")
                        let clickTextOpt2 = document.createElement("a")
                        let orText = document.createElement("span")
                        clickTextOpt1.addEventListener('click', function () {
                            openExplanationModal(currentRowID, warningError.errorId, value, warningError);
                        }, false);
                        clickTextOpt2.addEventListener('click', function () {
                            dismissWarning(warningError.qName, warningError.rowID, warningError.errorId, store.local.dismissText);
                        }, false);

                        clickTextOpt2.innerHTML = `click to dismiss`
                        clickTextOpt2.className = "click-to-dismiss"
                        orText.innerHTML = " or "

                        //Warnings on cell
                        if (warningError.errorTypeID == 2 && isDefault == -1) {
                            var className = "";
                            if (warningError.errorExplanation == null || warningError.errorExplanation.length === 0) {
                                clickTextOpt1.innerHTML = `<br/>Add Explanation`
                                clickTextOpt1.className = "click-to-dismiss"

                                span.appendChild(clickTextOpt1)
                                span.appendChild(orText)
                                span.appendChild(clickTextOpt2)
                                className = " validationWarning"
                            }
                            else {
                                clickTextOpt1.innerHTML = warningError.errorExplanation
                                clickTextOpt1.className = "error-explanation-text"

                                span.innerHTML += '<br/>Your comment: '
                                span.appendChild(clickTextOpt1)
                                className = ibsStore.accountInfo.UserRoleID === 3 ? " dismissed" : " dismissedInvisible"
                            }

                            if (isDefault > -1) {
                                console.log(ibsStore.defaultCoordinates[isDefault].value)
                                let valFormatted = ibsStore.defaultCoordinates[isDefault].value == "N/A" ? "N/A" : formatNumber(props.formatting[col], toNumber(ibsStore.defaultCoordinates[isDefault].value))
                                let clickTextOptReplaceDefault = document.createElement("a")
                                let orText2 = document.createElement("span")

                                if (warningError.errorExplanation != "Used Default") { // Not 100% on this one
                                    orText2.innerHTML = " or "
                                    clickTextOptReplaceDefault.innerHTML = `<br/>Use Imputed Value` // Not 100% on this one either
                                }
                                clickTextOptReplaceDefault.className = "click-to-dismiss"
                                clickTextOptReplaceDefault.addEventListener('click', function () {
                                    dismissWarning(warningError.qName, warningError.rowID, warningError.errorId, store.local.dismissText);
                                }, false);
                                td.innerHTML = valFormatted;

                                span.appendChild(orText2)
                                span.appendChild(clickTextOptReplaceDefault)
                                className = ibsStore.defaultCoordinates[isDefault].genericDefault ? " defaultVal" : " defaultValCalc"

                            }
                            td.className = td.className + className;
                        }
                        else if ((warningError.errorTypeID == 1 || warningError.errorTypeID == 0) && !ibsStore.isMandateDefaultsShown) {
                            td.className = td.className + " validationError"
                        }

                    }
                    else if (isDefault > -1) {
                        let valFormatted = ibsStore.defaultCoordinates[isDefault].value == "N/A" ? "N/A" : formatNumber(props.formatting[col], toNumber(ibsStore.defaultCoordinates[isDefault].value))
                        let averageVal = toNumber(ibsStore.defaultCoordinates[isDefault].average);
                        let averageFormatted = formatNumber(NumberFormat.MONEYDECIMAL1, Number.isNaN(averageVal) ? 0 : averageVal);
                        td.innerHTML = valFormatted;
                        td.className = td.className + (ibsStore.defaultCoordinates[isDefault].genericDefault ? " defaultVal" : " defaultValCalc")
                        span.className += " defaultTooltip"
                        if (hasAdded) {
                            span.innerHTML += "<br/>"
                        }
                        let defaultMsg = ibsStore.defaultCoordinates[isDefault].message.replace("{0}", valFormatted).replace("{1}", averageFormatted);
                        span.innerHTML += defaultMsg;
                        hasAdded = true;
                    }
                    else if (isOverride > -1) {
                        if ((prop != "ReturnPct" && prop != "InternalMonitoringCost" && prop != "CostInternManage")) {
                            return
                        }
                        td.className = td.className + " overrideAssetVal"
                        if (hasAdded) {
                            span.innerHTML += "<br/>"
                        }

                        if (col === 7 || col === 8) { //never use indexes..
                            span.innerHTML += `${formatNumber(props.formatting[col], value)} is an override entered by you. It replaces ${formatNumber(props.formatting[col], listOfOverrides[isOverride].calculated)} which is the weighted average return of mandates with this asset class style. Clear this cell to allow it to be calculated automatically.`
                        } else {
                            span.innerHTML += `${formatNumber(props.formatting[col], value)} is an override entered by you. It replaces ${formatNumber(props.formatting[col], listOfOverrides[isOverride].calculated)} which is the sum of mandates with this asset class style. Clear this cell to allow the field to be calculated automatically.`
                        }
                        hasAdded = true;


                    }
                    else if (isCalculated > -1) {
                        td.className = td.className + " calculatedAsset"
                        if (hasAdded) {
                            span.innerHTML += "<br/>"
                        }
                        let overrideMsg = "You can override the calculation by entering a value."
                        let showOverrideMsg = (prop == "ReturnPct" || prop == "InternalMonitoringCost")
                        if (col === 7 || col === 8) {
                            span.innerHTML += formatNumber(props.formatting[col], listOfCalculated[isCalculated].calculated) + " is the weighted average return of mandates with this asset class style. " + (showOverrideMsg ? overrideMsg : "");
                        } else {
                            span.innerHTML += formatNumber(props.formatting[col], listOfCalculated[isCalculated].calculated) + " is the sum of mandates with this asset class style. " + (showOverrideMsg ? overrideMsg : "Clear out the mandate-level data to enter data at the asset class level.");
                        }
                        hasAdded = true;
                    }

                }
                td.className = td.className.replace(" readOnlyCell", "");
                td.className = td.className + " tooltipCustom"

                var rightAligndiv = document.createElement("div");
                rightAligndiv.className = "rightAligned";
                rightAligndiv.appendChild(span);
                td.appendChild(rightAligndiv);
            }

            if (warningErrorIndex !== -1 && (isDefault > -1 || isCalculated > -1 || isOverride > -1)) {
                let currentWarningError = listOfErrorWarning[warningErrorIndex];
                var logErrorType = '';
                if (currentWarningError.errorTypeID == 1) {
                    store.overridenErrors[`${currentWarningError.qName}${currentWarningError.rowID}`] = 1;
                    logErrorType = 'Error'
                }
                else if (currentWarningError.errorTypeID == 2 && (currentWarningError.errorExplanation == null || currentWarningError.errorExplanation.length === 0)) {
                    store.overridenWarnings[`${currentWarningError.qName}${currentWarningError.rowID}`] = 1;
                    logErrorType = 'Warning'
                }
            }
        }

    };

    /**
     * insert missing asset class rows when there is mandate row but no asset row
     */
    const insertMissingAssetClassRows = () => {
        let missingAssetClassRows = [];
        // if mandate does not have an asset class row to act as parent row, the asset class row should be inserted
        for (const mandate of ibsStore.mandateData) {
            const mandateAssetClassId = mandate.assetClassID;
            const mandateStyleId = mandate.styleID;

            let correspondingAssets = ibsStore.allTableResponses["combinedAssets"]
                .filter(asset => asset.AssetClassID === mandateAssetClassId && asset.StyleID === mandateStyleId)

            if (correspondingAssets <= 0) {
                // corresponding asset not found, insert to the missing asset class row list, to insert later
                missingAssetClassRows.push({ mandateAssetClassId, mandateStyleId })
            }
        }

        // Insert missing asset class rows, so that it can act as parent to the corresponding mandate
        for (const rowToInsert of missingAssetClassRows) {
            //temp conditional TO:DO
            if (rowToInsert.mandateAssetClassId !== 999) insertRowCtrl(rowToInsert.mandateAssetClassId, rowToInsert.mandateStyleId, "combinedAssets")
        }
    }

    //For Assets table in DB
    const createDBAssetsData = () => {
        log(`createDBAssetsData`, 1);
        let rowCount = -1;
        listOfHeaderRows = [] //keep track of what rows are headers
        if (!ibsStore.allTableResponses["combinedAssets"]) {
            toast("Internal error: unable to retrieve data", {
                position: toast.POSITION.BOTTOM_RIGHT,
                draggable: false,
                autoClose: 4000,
                hideProgressBar: true,
                className: "red-notif"
            });

            return null;
        }

        let mandateLevelInt = null
        if (typeof ibsStore.checkMandateLevel !== "undefined" && ibsStore.checkMandateLevel !== null) {
          mandateLevelInt = parseInt(ibsStore.checkMandateLevel, 10);
        }

        if (ibsStore.mandateData?.length > 0) insertMissingAssetClassRows();

        let runSearchFilterOn = ["AssetClassName", "StyleName", "ManagerName", "FundName", "ReturnTypeIDAssets", "AssetClassNameReal", "InternalTeamID"];

        //MANDATE ONLY TABLE
        if (mandateLevelInt == AssetTableViewMode.MANDATE_ONLY_VIEW) {
            const uniqueAssetCategories = ibsStore.mandateData.slice().reduce((prev, cur) => {
                if (!prev[cur.assetClassCategoryName]) {
                    prev[cur.assetClassCategoryName] = [];
                }
                prev[cur.assetClassCategoryName].push(toJS(cur));
                return prev;
            }, {});

            // Reduce categoriesToRender to a single category if mandateCategoryToRender is not "All"
            let categoriesToRender = uniqueAssetCategories;
            if (ibsStore.mandateCategoryToRender !== "All") {
                categoriesToRender = {};
                if (uniqueAssetCategories[ibsStore.mandateCategoryToRender]) {
                    categoriesToRender[ibsStore.mandateCategoryToRender] = uniqueAssetCategories[ibsStore.mandateCategoryToRender];
                }
            }

            for (let currentCategoryName of Object.keys(categoriesToRender)) {
                // Render category rows if no search is acitve
                // Only render if there is a mandate in the current category
                let firstMandate = true;

                for (const mandate of categoriesToRender[currentCategoryName]) {
                    const mandateRow = RowFactory.CreateMandateRow(mandate);

                    if (ibsStore.mandateSearchToRender === null) {
                        if (firstMandate) {
                            const categoryTypeRow = RowFactory.CreateCategoryHeaderRow(currentCategoryName);
                            rowCount = rowCount + 1
                            listOfHeaderRows.push(rowCount)
                            referenceToTable.push(categoryTypeRow)
                            dataObj.push(categoryTypeRow);
                            firstMandate = false;
                        }
                        rowCount = rowCount + 1;
                        referenceToTable.push(mandateRow);
                        dataObj.push(mandateRow);
                    }
                    else {
                        for (let columnToSearch of runSearchFilterOn) {
                            if (String(mandateRow[columnToSearch])?.toLowerCase()?.includes(ibsStore.mandateSearchToRender?.toLowerCase())) {
                                if (firstMandate) {
                                    const categoryTypeRow = RowFactory.CreateCategoryHeaderRow(currentCategoryName);
                                    rowCount = rowCount + 1
                                    listOfHeaderRows.push(rowCount)
                                    referenceToTable.push(categoryTypeRow)
                                    dataObj.push(categoryTypeRow);
                                    firstMandate = false;
                                }
                                rowCount = rowCount + 1;
                                referenceToTable.push(mandateRow);
                                dataObj.push(mandateRow);
                                break;
                            }
                        }

                    }
                }


            }

        } else if (mandateLevelInt != AssetTableViewMode.MANDATE_ONLY_VIEW) {
            //This is the Combined View
            let uniqueAssetCategories;
            let renderHeaderRows = true;

            // the "Combined" view (shows asset class and mandates in the same table)
            if (ibsStore.mandateCategoryToRender == "All") {
                uniqueAssetCategories = [...new Set(ibsStore.allTableResponses["combinedAssets"].map(asset => asset.AssetClassCategoryName))];
            } else {
                uniqueAssetCategories = [ibsStore.mandateCategoryToRender]
            }


            for (const currentCategoryName of uniqueAssetCategories) {
                let firstAssetCategory = true;

                let assetClassRowsForCurrentCategory = ibsStore.allTableResponses["combinedAssets"]
                    .filter(asset => asset.AssetClassCategoryName === currentCategoryName)
                    .map(asset => JSON.parse(JSON.stringify(asset)))
                    .sort(DbSortFunctionForAssets);

                for (const assetClass of assetClassRowsForCurrentCategory) {
                    let firstAssetClass = true;
                    const detachedMandates = JSON.parse(JSON.stringify(ibsStore.mandateData
                        .filter(mandate => mandate.assetClassID === assetClass.AssetClassID && mandate.styleID === assetClass.StyleID)
                        .map(mandate => mandate)));

                    let assetClassRow = {};
                    assetClassRow = RowFactory.CreateAssetRow(assetClass, detachedMandates, listOfOverrides, listOfCalculated);


                    if (ibsStore.mandateSearchToRender === null) {
                        // If no search filter is applied, push the asset class category header if nessisary
                        if (firstAssetCategory && renderHeaderRows) {
                            const categoryTypeRow = RowFactory.CreateCategoryHeaderRow(currentCategoryName);
                            rowCount = rowCount + 1
                            listOfHeaderRows.push(rowCount)
                            referenceToTable.push(categoryTypeRow)
                            dataObj.push(categoryTypeRow);
                            firstAssetCategory = false;
                        }
                        // If no search filter is applied, push the asset class if nessisary
                        if (Object.keys(assetClassRow).length != 0 && firstAssetClass) {
                            rowCount = rowCount + 1
                            listOfAssetRows.push(rowCount);
                            referenceToTable.push(assetClassRow);
                            dataObj.push(assetClassRow);
                            firstAssetClass = false;
                        }
                    }
                    else {
                        // If a search filter is applied, push the asset class category header and asset class row only if the search criteria is matched by the asset class row
                        for (let columnToSearch of runSearchFilterOn) {
                            if (Object.keys(assetClassRow).length != 0 && firstAssetClass && assetClassRow[columnToSearch]
                                && String(assetClassRow[columnToSearch])?.toLowerCase()?.includes(ibsStore.mandateSearchToRender?.toLowerCase())) {
                                if (firstAssetCategory && renderHeaderRows) {
                                    const categoryTypeRow = RowFactory.CreateCategoryHeaderRow(currentCategoryName);
                                    rowCount = rowCount + 1
                                    listOfHeaderRows.push(rowCount)
                                    referenceToTable.push(categoryTypeRow)
                                    dataObj.push(categoryTypeRow);
                                    firstAssetCategory = false;
                                }
                                if (Object.keys(assetClassRow).length != 0 && firstAssetClass) {
                                    rowCount = rowCount + 1
                                    listOfAssetRows.push(rowCount);
                                    referenceToTable.push(assetClassRow);
                                    dataObj.push(assetClassRow);
                                    firstAssetClass = false;
                                }
                                break;
                            }
                        }
                    }

                    const childRowsForAssetClass = [];

                    // Push the mandate rows if there are any and if they meet the search criteria
                    if (mandateLevelInt == AssetTableViewMode.BOTH_VIEW && detachedMandates.length > 0) {
                        for (const mandate of detachedMandates) {
                            let lpRowMatch;
                            let parentAssetRowID = assetClassRow.RowID
                            if (mandate.assetClassCategoryName == "Private Equity") lpRowMatch = ibsStore.allTableResponses["PrivateEquity"]?.filter(lpRow => lpRow.PartnershipName == mandate.fundName)[0]; //not sure if used
                            const mandateRow = RowFactory.CreateMandateRow(mandate, parentAssetRowID);

                            // If there is no search, we know that the asset class row and asset class category header have been pushed
                            if (ibsStore.mandateSearchToRender === null) {
                                rowCount = rowCount + 1
                                childRowsForAssetClass.push(mandateRow);
                                referenceToTable.push(mandateRow)
                            }
                            else {
                                for (let columnToSearch of runSearchFilterOn) {
                                    if (String(mandateRow[columnToSearch])?.toLowerCase()?.includes(ibsStore.mandateSearchToRender?.toLowerCase())) {
                                        if (firstAssetCategory && renderHeaderRows) {
                                            const categoryTypeRow = RowFactory.CreateCategoryHeaderRow(currentCategoryName);
                                            rowCount = rowCount + 1
                                            listOfHeaderRows.push(rowCount)
                                            referenceToTable.push(categoryTypeRow)
                                            dataObj.push(categoryTypeRow);
                                            firstAssetCategory = false;
                                        }
                                        if (Object.keys(assetClassRow).length != 0 && firstAssetClass) {
                                            rowCount = rowCount + 1
                                            listOfAssetRows.push(rowCount);
                                            referenceToTable.push(assetClassRow);
                                            dataObj.push(assetClassRow);
                                            firstAssetClass = false;
                                        }
                                        rowCount = rowCount + 1
                                        childRowsForAssetClass.push(mandateRow);
                                        referenceToTable.push(mandateRow)
                                        break;
                                    }
                                }

                            }
                        }
                        assetClassRow['__children'] = childRowsForAssetClass;

                    }
                }
            }
        }

        const totalRow = {
            AssetClassCategoryName: "Total",
            AssetClassName: "",
            StyleName: "",
            ManagerName: "",
            FundName: "",
            HoldingNavAvg: columnCalculation("HoldingNavAvg", NumberFormat.MONEYMILLION),
            HoldingNavEnd: columnCalculation("HoldingNavEnd", NumberFormat.MONEYMILLION),
            ReturnPct: "",
            placeholder1: '',
            CostManagerBase: columnCalculation("CostManagerBase", NumberFormat.MONEYTHOUSAND),
            CostManagerPerf: columnCalculation("CostManagerPerf", NumberFormat.MONEYTHOUSAND),
            CostUnderlyBase: columnCalculation("CostUnderlyBase", NumberFormat.MONEYTHOUSAND),
            CostUnderlyPerf: columnCalculation("CostUnderlyPerf", NumberFormat.MONEYTHOUSAND),
            CostInternManage: columnCalculation("CostInternManage", NumberFormat.MONEYTHOUSAND),
            totalRowCost: columnCalculation("totalRowCost", NumberFormat.MONEYTHOUSAND),
            HoldingFeeAvg: columnCalculation("HoldingFeeAvg", NumberFormat.MONEYMILLION),
            HoldingFeeEnd: columnCalculation("HoldingFeeEnd", NumberFormat.MONEYMILLION),
            InternalTeamID: "",
            LifeCycleStatus: "",
            RowID: "Total",
            action: " ",
            __children: null
        }
        listOfHeaderRows.push(rowCount + 1)
        dataObj.push(totalRow)
        referenceToTable.push(totalRow)

        loadMandateTableErrors();

        rowJustAdded = referenceToTable.findIndex(
            (element) => element.RowID === ibsStore.lastRowAdded || element.RowID === `A${ibsStore.lastRowAdded}`
        )

        return dataObj;
    }

    const loadMandateTableErrors = () => {
        log(`loadMandateTableErrors`, 1);
        if (store.allValidationErrorsList["mandate_data"]) {
            store.allValidationErrorsList["mandate_data"].forEach(error => {
                listOfErrorWarning.push({
                    "qName": error.QuestionName,
                    "rowID": error.RowID,
                    "errorTypeID": error.ErrorTypeID,
                    "errorMessage": error.ErrorMessage,
                    "errorExplanation": error.ErrorExplanation,
                    "errorTotalCol": error.totalErrorColumn,
                    "errorId": error.ErrorId 
                })

            })

        }
        if (store.allValidationErrorsList[store.currentLandedPage]) {
            store.allValidationErrorsList[store.currentLandedPage].forEach(error => {
                listOfErrorWarning.push({
                    "qName": error.QuestionName,
                    "rowID": error.RowID,
                    "errorTypeID": error.ErrorTypeID,
                    "errorMessage": error.ErrorMessage,
                    "errorExplanation": error.ErrorExplanation,
                    "errorTotalCol": error.totalErrorColumn,
                    "errorId": error.ErrorId
                })
            });
        }
    }

    const columnCalculation = (colId, format = null) => {
        let total = 0;

        let mandateLevelInt = null
        if (typeof ibsStore.checkMandateLevel !== "undefined" && ibsStore.checkMandateLevel !== null) {
          mandateLevelInt = parseInt(ibsStore.checkMandateLevel, 10);
        }

        if (referenceToTable) {
            const initialValueForReduce = 0;
            total = dataObj
                .filter(row => {
                    const rowIdString = row?.RowID?.toString();
                    if (rowIdString === "")
                        return false;

                    if (mandateLevelInt == AssetTableViewMode.MANDATE_ONLY_VIEW) {
                        // in mandateOnly View
                        // sum all rows that has rowId
                        return true;
                    } else {
                        // in "both" View
                        // only sum the rows that has prefix 'A'
                        return rowIdString?.startsWith("A");
                    }
                })
                .map((row) => {

                    if ((colId == "costInternManage" || colId == "costInternMonitor")) {
                        let actualRow = ibsStore.mandateData.find(mandate => mandate["rowID"] === row["RowID"]);
                        if (actualRow && isInternalStyle(actualRow["styleID"])) {
                            colId = "CostInternManage"
                        }
                        else {
                            colId = "CostInternMonitor"

                        }
                    }
                    if (colId == "CostInternMonitor") {
                        colId = "CostInternManage"
                    }

                    let val = row[colId]

                    if (val === undefined || val === null || val === "" || val === "N/A" || row.AssetClassCategoryName == 'Total')
                        val = 0;

                    return parseFloat(toNumber(val))
                })
                .reduce((sum, val) => {
                    return sum + val;
                }, initialValueForReduce)
        }

        //add defaults for this column, only in mandate only view
        if (mandateLevelInt == AssetTableViewMode.MANDATE_ONLY_VIEW || mandateLevelInt == AssetTableViewMode.BOTH_VIEW) {
            let fieldID = colId.charAt(0).toLowerCase() + colId.slice(1);
            let defaultsTotal = 0;
            let mandateToAssetMap = mandateToAssetMapping[colId]
            let defaultsForRow = ibsStore.defaultCoordinates.filter(def => def.qName === fieldID || def.qName == mandateToAssetMap);
            //let rowsShown = dataObj.map((row) => row.RowID).filter((RowID) => (typeof RowID === "number" || RowID.substring(1)=== "number") && !isNaN(RowID))
            let rowsShown = dataObj.map((row) => row.RowID).filter((RowID) => (RowID !== ""))
            defaultsTotal = defaultsForRow.map((row) => {
                if (row.value == "N/A") row.value = 0
                if (rowsShown.includes(row?.rowID)) {
                    return parseFloat(toNumber(row.value));
                }
                else {
                    return 0;
                }

            })
                .reduce((sum, val) => {
                    return sum + val;
                }, 0)
            total = total + defaultsTotal;
        }


        if (!format) return total
        total = formatNumber(format, total)
        //return parseFloat(toNumber(total));
        return (total)

    }

    //Data handler (check if its DB assets table or not)
    const handleData = () => {
        log(`handleData`, 1);
        //hope this only will not get retriggered when we update the overriden stuff
        store.overridenWarnings = {};
        store.overridenErrors = {};
        return createDBAssetsData()
    }

    const getMergedCells = () => {
        log(`getMergedCells`, 4);
        let merged = []
        listOfHeaderRows.forEach(rowIdx => merged.push({ row: rowIdx, col: 0, rowspan: 1, colspan: 4 }))
        for (let i = 0; i < referenceToTable.length; i++) {
            if (referenceToTable[i].RowID?.toString().startsWith("A")) merged.push({ row: i, col: 1, rowspan: 1, colspan: 3 })

        }
        return merged;
    }

    /* Fixed Header */
    let isScrolledPastHeader = false;
    let fullSizeTableIds = ['AssetAllocation', 'combinedAssets', 'Benchmark', 'mandate'];

    function isScrolledPast(el, table, offset = 0) {
        //check here Manisha
        log(`isScrolledPast`, 4);
        var headerRect = el.getBoundingClientRect();
        var tableRect = table.getBoundingClientRect();
        var headerTop = headerRect.top;
        var headerBottom = headerRect.bottom;
        var tableBottom = tableRect.bottom;

        /* Return true if element is above the top offset and below the window bottom (offset + (headerBottom - headerTop)*/
        var isVisible = ((headerTop - offset) < 0) && (tableBottom > (offset + (headerBottom - headerTop)));
        return isVisible;
    }

    /**
     * helper dictionary for getCellFormat
     * @type {{}} { qId: cellFormat }
     */
    const cellFormatDictionary = {};

    /**
     * Returns cached cellFormat from props.formatting[col]
     * @param table
     * @param qId
     */
    function getCellFormat(table, qId) {
        log(`getCellFormat`, 4);
        // check if answer is ready
        if (qId in cellFormatDictionary) {
            return cellFormatDictionary[qId];
        }

        const col = table.propToCol(qId);

        let cellFormat = undefined;
        if (props.formatting && props.formatting[col])
            cellFormat = props.formatting[col];

        // save result
        cellFormatDictionary[qId] = cellFormat;

        return cellFormat;
    }

    /**
     * helper dictionary for isNumField
     * @type {{}} qId: isNumField
     */
    const isNumFieldDictionary = {};

    /**
     * Checks whether the column with propQid = qId is a number field or not
     * @returns {boolean}
     */
    function isNumField(table, qId) {
        log(`isNumField`, 1);
        // check if answer is ready
        if (qId in isNumFieldDictionary) {
            return isNumFieldDictionary[qId];
        }

        let cellFormat = getCellFormat(table, qId);
        const isNumField = Object.values(NumberFormat).indexOf(cellFormat) > -1;

        // save result
        isNumFieldDictionary[qId] = isNumField;

        return isNumField;
    }

    /**
     * In case the value entered isn't ideal. This function will auto fix it to some extent.
     * e.g. 4.563.214.2 => 4.563
     * e.g. 4.7 % => 4.7
     * @param changes
     * @param source
     */
    const fixValueBeforeChange = function (changes, source) {
        log(`fixValueBeforeChange`, 1);
        const propQId = changes[0][1];
        const newVal = changes[0][3];
        // if null just let the value pass through

        if (newVal === null || newVal === "")
            return null;
        if ((propQId == "ReturnPct") && store.local.naList.includes(newVal)) {//is this right
            changes[0][3] = "N/A"
        }
        else if (isNumField(this, propQId)) {
            // clean up the value if it's a number (auto fix stuff)
            let normalizedValue = "";

            const cellFormat = getCellFormat(this, propQId);
            if (cellFormat === NumberFormat.PERCENTAGE ||
                cellFormat === NumberFormat.PERCENTAGE_UK ||
                cellFormat === NumberFormat.PERCENTAGEINTEGER) {
                // If it's a percentage field, remove the percentage symbol if it exists
                normalizedValue = toNumber(newVal.toString().replace('%', ''));
            } else {
                normalizedValue = toNumber(newVal);
            }

            changes[0][3] = localizeNumber(normalizedValue);
        }
    }

    /* Scroll listener for fixed header */
    useEffect(() => {
        log(`useEffect isScrolledPastHeader`, 1);
        const handleScroll = () => {
            if (fullSizeTableIds.indexOf(props.tableName) > -1 && store.currentLandedPage !== "print") {
                /*
                    Hot table renders two headers, the original one attached to the
                    table which is hidden, and a duplicate which is displayed.
    
                    Track the original headers position, and if it is off screen,
                    stick the duplicate to just below the navbar
                */
                let origTable = document.querySelector(".ht_master.handsontable");
                let origTableHeader = document.querySelector(".ht_master.handsontable thead");
                let navBarDiv = document.querySelector("div.fixed-top");
                let navBar = document.querySelector("div.fixed-top > nav.navbar");
                if (origTableHeader && navBarDiv && navBar) {
                    /* Navbar height is off when in mobile mode so check both outer and inner nav elements */
                    let actualNavHeight = Math.max(navBarDiv.clientHeight, navBar.clientHeight);
                    let updatedIsScrolledPast = isScrolledPast(origTableHeader, origTable, actualNavHeight);
                    let dupHeader = document.querySelector(".ht_clone_top.handsontable");

                    if (updatedIsScrolledPast !== isScrolledPastHeader) {
                        if (updatedIsScrolledPast) {
                            dupHeader.classList.add('stuck');
                            dupHeader.style.position = 'fixed';
                            dupHeader.style.top = `${actualNavHeight}px`;
                            dupHeader.style.removeProperty('left');
                        } else {
                            dupHeader.classList.remove('stuck');
                            dupHeader.style.position = 'absolute';
                            dupHeader.style.top = `0`;
                            dupHeader.style.left = `0`;
                        }
                        isScrolledPastHeader = updatedIsScrolledPast + 200;
                    }

                    if (dupHeader.classList.contains('stuck')) {
                        /* Double check height compared to navbar */
                        let offsetY = dupHeader.style.top;
                        if (`${actualNavHeight}px` != offsetY) {
                            dupHeader.style.top = `${actualNavHeight}px`;
                        }

                        /* Set the left based on the scroll */
                        var leftLen = origTableHeader.getBoundingClientRect().left;
                        dupHeader.style.left = `${leftLen}px`;
                    }
                }
            }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });

        return () => window.removeEventListener("scroll", handleScroll);
    }, [isScrolledPastHeader]);

    /* Resize listener for fixed header */
    useEffect(() => {
        log(`resizeListener`, 1);
        const handleResize = () => {
            /* On resize, compare to navbar as the navbar height may change between desktop/mobile */
            let dupHeader = document.querySelector(".ht_clone_top.handsontable");
            let navBarDiv = document.querySelector("div.fixed-top");
            let navBar = document.querySelector("div.fixed-top > nav.navbar");

            let actualNavHeight = Math.max(navBarDiv.clientHeight, navBar.clientHeight);

            if (dupHeader.classList.contains('stuck')) {
                let offset = dupHeader.style.top;
                if (`${actualNavHeight}px` != offset) {
                    dupHeader.style.top = `${actualNavHeight}px`;
                }
            }
        }

        window.addEventListener("resize", handleResize, { passive: true });

        return () => window.removeEventListener("resize", handleResize);
    });


    const mandateCells = (row, col, prop) => {
        var cellProperties = {};
        var cellProperties = { wordWrap: false };
        //If it a category Row, special formatting
        var delCol = props.headers.findIndex((element) => element === "del");
        var actionCol = props.headers.findIndex((element) => element === "action");
        var totalCol = props.headers.findIndex((element) => element === "totalRowCost");
        var lifecycleCol = props.headers.findIndex((element) => element === "LifeCycleStatus");
        var reportIncludeCol = props.headers.findIndex((element) => element === "ReportIncludeStatus");

        if (listOfHeaderRows.includes(row) && col != actionCol) {
            cellProperties.renderer = categoryRowRenderer
            cellProperties.readOnly = true;

        }
        else if (prop == "ReturnTypeIDAssets") {
            cellProperties.source = getOptionsArray(returnTypeIDOptions(referenceToTable[row].RowID))

            if (isCellNA(row, col, props, referenceToTable)) {
                cellProperties.renderer = dropdownNARenderer

            }


        } else if (prop == "CustomAssetID" || prop == "InternalTeamID") {
            checkDropdownReadonly(row, prop, cellProperties)
            if (cellProperties.renderer === readOnlyRenderer) {
                return;
            }
        }
        //For enhanced internal == 6, they can only fill either custom grouping or internal asset fields (not both)
        if (ibsStore.currentSurvey.EnhancedInternalID == 6) {
            let customGroupCell = referenceToTable[row]["CustomAssetID"]
            let internalTeamCell = referenceToTable[row]["InternalTeamID"]

            if (prop == 'InternalTeamID' && internalTeamCell == "" && customGroupCell != "") {
                cellProperties.renderer = readOnlyRenderer
                cellProperties.readOnly = true
                return;

            } else if (prop == 'CustomAssetID' && customGroupCell == "" && internalTeamCell != "") {
                cellProperties.renderer = readOnlyRenderer
                cellProperties.readOnly = true
                return;
            }


        }

        if (col === delCol || col === actionCol) {
            cellProperties.readOnly = true;
        }
        if (col === totalCol) {
            cellProperties.readOnly = true;
        }

        // Remove the mandate lifecyclestatus dropdown from assets
        if (listOfAssetRows.indexOf(row) > -1 && col === lifecycleCol) {
            cellProperties.readOnly = true;
            cellProperties.renderer = categoryRowRenderer
        }

        if (row == referenceToTable.length - 1) {
            cellProperties.cellType = "text"
        }


        return cellProperties;
    }



    const checkDropdownReadonly = (row, prop, cellProperties) => {
        let currentRowID
        if (referenceToTable[row]) currentRowID = referenceToTable[row].RowID
        if (currentRowID && currentRowID[0] != "A") {
            //lock out the mandate row
            let anyAssetFilled = checkAnyAssetCellFilled(referenceToTable[row].ParentAssetRowId)
            if (anyAssetFilled) {
                cellProperties.readOnly = true
                cellProperties.renderer = readOnlyRenderer
            } else {
                cellProperties.readOnly = false
            }

        } else {
            //lock out the asset row
            let anyMandateFilled = checkAnyMandateFilled(referenceToTable[row].RowID)
            if (anyMandateFilled) {
                cellProperties.readOnly = true
                cellProperties.renderer = readOnlyRenderer

            } else {
                cellProperties.readOnly = false

            }
        }
    }

    let updateMandateSearchBox = (updateText) => {
        $('#searchInput2').val(updateText);
    }

    useEffect(() => {
        updateMandateSearchBox((typeof ibsStore.mandateSearchToRender !== "string") ? "" : ibsStore.mandateSearchToRender);

    });

    const cellRenderer = (instance, td, row, col, prop, value, cellProperties) => {
        return assetMandateCellRenderer(instance, td, row, col, prop, value, cellProperties, props, referenceToTable, lastEncounteredImplStyle, lastEncounteredAssetCat, listOfAssetRows, rowJustAdded)
    }

    let avgAssetsGiv = getSurveyResponseValue("IsAvgAssetsGiv")
    if (ibsStore.checkMandateLevel == null || avgAssetsGiv === "")
        return (null)

    return (
        <React.Fragment>
            {MandateTableButtons(hotTableInstance, referenceToTable, props)}

            <div style={props.styleOverride} className={classNames(props.tableName, "fade-in")}>
                <div className="surveyCondensedTableContainer mandate">

                    <HotTable root="hot"
                        renderAllRows={store.currentLandedPage === "print"}
                        startRows={0}
                        data={handleData()}
                        nestedHeaders={getAssetTableHeaders(true, props)}
                        ref={hotTableInstance}
                        autoColumnSize={true}
                        wordWrap={false}
                        fixedColumnsLeft={props.fixedCols}
                        manualColumnResize={true}
                        beforeChange={function (changes, source) {
                            if (source != "skipHotChange") fixValueBeforeChange
                        }}
                        afterSelectionEnd={function (r, c, r2, c2) {
                        }}
                        afterChange={function (changes, source) {
                            if (changes === null) {
                                this.updateSettings({
                                    nestedHeaders: getAssetTableHeaders(true, props)
                                })

                            } else {

                                const rowNum = changes[0][0];
                                const propQId = changes[0][1];
                                const oldVal = changes[0][2];
                                const newVal = changes[0][3];

                                if (source != "skipHotChange") handleHOTChange(this, rowNum, propQId, oldVal, newVal)
                                if (typeof rowJustAdded !== "undefined" && rowJustAdded !== null && rowNum === rowJustAdded) {
                                    ibsStore.lastRowAdded = null;
                                }
                            }
                        }}
                        readOnly={!store.userCanEditReadOnlySurvey || store.questionMode}
                        deselect={function () {

                        }}
                        enterMoves={{ row: 0, col: 1 }}
                        width={'100%'}
                        renderer={cellRenderer}
                        dragToScroll={false}
                        trimDropdown={props.trimDropdown ? true : false}
                        cells={function (row, col, prop) {
                            return mandateCells(row, col, prop)
                        }}
                        columns={props.columns}
                        nestedRows={true}
                        mergeCells={getMergedCells()}
                        hiddenColumns={{ columns: getHiddenMandateColumns(props) }}
                        afterOnCellMouseDown={function (e, coords, TD) {
                            //last column in table is the delete button
                            var delCol = props.headers.findIndex((element) => element === "del");
                            var actionCol = props.headers.findIndex((element) => element === "action");
                            if (coords.col === actionCol) {
                                if (coords.row != -1 && coords.row != -2) openMandatesActionModal(coords.row, props, referenceToTable)
                                //deselect cell if possible (want it to not look like part of the table!!)
                            }
                            if (coords.col === props.headers.findIndex((element) => element === "ManagerName")
                                || coords.col === props.headers.findIndex((element) => element === "AssetClassName")) {
                                var now = new Date().getTime();
                                if (!(TD.lastClick && now - TD.lastClick < 500)) {
                                    TD.lastClick = now;
                                }
                                else {
                                    openMandatesActionModal(coords.row, props, referenceToTable);
                                }
                            }

                        }}
                        licenseKey={'f9ac8-f01c1-70bd1-f4c2a-0e43c'}
                        handleHotBeforeOnCellMouseDown={function (event, coords, element) {
                            if (coords.col === 14 && coords.row != -1 && coords.row != -2) {
                                event.stopImmediatePropagation();
                            }
                        }}
                        viewportRowsRenderingOffset={50}
                        afterSelection={(r, c, r2, c2, preventScrolling, selectionLayerLevel) => {
                            preventScrolling.value = true;
                        }}
                        afterColumnResize={(newSize, column) => {
                            colWidthsOverrides = updateColumnWidths(colWidthsOverrides, newSize, column, props);
                            manageContainerWidth(true);
                        }}
                        colWidths={colWidthsOverrides[props.tableName] ? undefined : props.colWidths}
                        afterRenderer={function (td, row, column, prop, value, cellProperties) {
                            errorRenderer(td, row, column, prop, value, cellProperties);

                        }}
                        afterRender={() => {
                            manageContainerWidth()
                            /* 
                                There seems to be a bug where on load after
                                render the hotInstance isn't available yet,
                                try again after 1 second to properly fit the
                                table
                            */
                            setTimeout(() => manageContainerWidth(), 1000);
                            if (hotTableInstance?.current?.hotInstance) ibsStore.mandateTableInstance = hotTableInstance.current.hotInstance;

                            let tableWidth = $('.surveyCondensedTableContainer.mandate')?.find('.wtHider')?.width();
                            tableWidth = tableWidth ? tableWidth.toString() + 'px' : 'auto';
                            $('.MandateMenu').css({
                                'width': tableWidth
                            });
                        }}
                        beforeRender={() => {
                            log(`beforeRender`, 1);
                            manageColumnWidths();
                        }}

                        search={true}
                        beforePaste={(changes, src) => {
                            // If changes don't exist, don't paste
                            if (!changes || !src) {
                                return false;
                            }
                            // If changes are limited to one cell, edit cell as normal
                            if (changes.length === 1 && (changes[1]?.length ?? 1) === 1) {
                                return true;
                            }

                            /* No multi paste - Mitch */
                            return false;

                        }}
                    />
                </div>
            </div>


        </React.Fragment>)

});
export default SurveyMandateTable;
